var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"value":_vm.show,"position-x":_vm.positionX,"position-y":_vm.positionY,"content-class":"tooltip-white","right":""}},[_c(_vm.viewComponent,{tag:"component",attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }